<template>
 <div id="home" style="height: auto">
  <OilTypeCard />

  <vx-card>
   <vs-row vs-w="12" class="my-5">
    <vs-col
     vs-type="flex"
     class="mb-1"
     vs-align="center"
     vs-lg="3"
     vs-sm="3"
     vs-xs="12"
    >
     <v-date-picker
      v-if="$i18n.locale == 'th'"
      class="cursor-pointer w-full"
      v-model="selectedDate"
      mode="date"
      is-range
      is24hr
      :locale="$i18n.locale"
      :buddhist="true"
      :max-date="new Date()"
     >
      <template v-slot="{ inputEvents }">
       <vs-input
        v-on="inputEvents.start"
        label="วันที่เริ่ม"
        :value="`${
         selectedDate.start ? setDateFormatTh(selectedDate.start) : ''
        } - ${selectedDate.end ? setDateFormatTh(selectedDate.end) : ''}`"
        class="w-full"
        placeholder="วัน/เดือน/ปี - วัน/เดือน/ปี"
       />
      </template>
     </v-date-picker>
    </vs-col>
    <vs-col
     vs-type="flex"
     class="mb-1"
     vs-align="center"
     vs-lg="4"
     vs-sm="4"
     vs-xs="12"
    >
      <form autocomplete="off" class="w-full">
        <vs-select
          id="searchVesselName"
          class="w-full select-large"
          label="ชื่อเรือประมง"
          v-model="selectedVessel"
          autocomplete
          placeholder="กรุณาเลือกเรือประมง"
        >
          <vs-select-item
          :key="index"
          :value="item"
          :text="item.name"
          v-for="(item, index) in optionsVessel"
          class="w-full"
          />
        </vs-select>
      </form>
    </vs-col>
    <vs-col
     vs-type="flex justify-center"
     class="mb-1"
     vs-align="center"
     vs-lg="4"
     vs-sm="4"
     vs-xs="12"
    >
     <div class="pt-2">
      <vs-button
       class="py-2 mt-5"
       color="#0066cc"
       type="border"
       icon-pack="feather"
       icon="icon-search"
       @click="getOilTransfers()"
       >ค้นหา</vs-button
      >
     </div>
    </vs-col>
   </vs-row>
   <!-- <hr class="my-10" /> -->
  </vx-card>

  <vx-card class="mt-5 z-0">
   <div class="px-5 pb-5 relative">
    <div class="flex justify-between">
     <div class="flex">
      <h5 class="my-5">ตารางการจัดส่งน้ำมัน</h5>
      <p
       class="pr-4 border-0 md:border-r border-solid border-grey-light mr-5"
      ></p>
      <div class="mt-5">
       <vs-chip color="#fdecb4">
        <p style="color: #000">
         ยอดรวมการรับน้ำมัน {{ formatNumber(totalOilVolume) }} ลิตร
        </p>
       </vs-chip>
      </div>
     </div>
     <div>
      <!-- <vs-button
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-printer"
              @click="print()"
            >
              พิมพ์
            </vs-button> -->
     </div>
    </div>
    <vs-table
     maxHeight="460px"
     class="static text-center mt-3"
     :max-items="descriptionItems[0]"
     description
     :description-items="descriptionItems"
     description-title="ลำดับ"
     description-connector="จาก"
     description-body="จำนวนต่อหน้า"
     pagination
     :data="oilTransfers"
    >
     <template slot="thead">
      <vs-th><p class="mx-auto text-center">ลำดับ</p></vs-th>
      <vs-th sort-key="start_at"
       ><p class="mx-auto text-center">วัน เดือน ปี / เวลา</p></vs-th
      >
      <!-- <vs-th><p class="mx-auto text-center"> โรงกลั่น </p></vs-th>
            <vs-th><p class="mx-auto text-center"> ชื่อเรือบรรทุกน้ำมัน </p></vs-th> -->
      <vs-th><p class="mx-auto text-center">เรือประมง</p></vs-th>
      <vs-th><p class="mx-auto text-center">ความจุถังน้ำมันเรือประมง</p></vs-th>
      <vs-th><p class="mx-auto text-center">เรือสถานีบริการน้ำมัน</p></vs-th>
      <vs-th
       ><p class="mx-auto text-center">
        ความจุถังน้ำมันเรือสถานีบริการน้ำมัน
       </p></vs-th
      >
      <vs-th><p class="mx-auto text-center">ตำแหน่ง(Lat,Lon)</p></vs-th>
      <vs-th sort-key="volume"
       ><p class="mx-auto text-center">ปริมาณน้ำมัน (ล.)</p></vs-th
      >
     </template>
     <template slot-scope="{ data }">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
       <vs-td>
        {{ tr.index + 1 }}
       </vs-td>

       <vs-td :data="data[indextr].start_at">
        {{ data[indextr].start_at }}
       </vs-td>

       <!-- <vs-td :data="data[indextr].station && data[indextr].station.name">
                <a
                  href="#"
                  @click="activeRefinary(data[indextr].station)"
                  >
                  {{ data[indextr].station && data[indextr].station.name }}
                  </a
                >
              </vs-td>

              <vs-td :data="data[indextr].forwardTanker && data[indextr].forwardTanker.name">
                {{ data[indextr].forwardTanker && data[indextr].forwardTanker.name }}
              </vs-td> -->

       <vs-td :data="data[indextr].vessel && data[indextr].vessel.name">
        {{ data[indextr].vessel && data[indextr].vessel.name }}
       </vs-td>

       <vs-td :data="data[indextr].vessel && data[indextr].vessel.capacity">
        {{ data[indextr].vessel && getVolume(data[indextr].vessel.capacity) }}
       </vs-td>

       <vs-td :data="data[indextr].tanker && data[indextr].tanker.name">
        {{ data[indextr].tanker && data[indextr].tanker.name }}
       </vs-td>

       <vs-td :data="data[indextr].tanker && data[indextr].tanker.capacity">
        {{ data[indextr].tanker && getVolume(data[indextr].tanker.capacity) }}
       </vs-td>

       <vs-td :data="data[indextr]">
        <a href="#" @click="isActiveNotification(data[indextr])"
         >{{ data[indextr].latitude }} , {{ data[indextr].longitude }}</a
        >
       </vs-td>

       <vs-td
        :data="data[indextr].volume"
        v-if="data[indextr].station && !data[indextr].tanker"
       >
        {{ getVolume(data[indextr].volume) }}
       </vs-td>
       <vs-td
        :data="data[indextr].volume"
        v-else-if="data[indextr].forwardTanker && data[indextr].tanker"
       >
        <p
         :style="
          checkCapacityAndVolume(
           data[indextr].tanker.capacity,
           data[indextr].volume
          )
           ? 'color: red'
           : 'color: green'
         "
        >
         {{ getVolume(data[indextr].volume) }}
        </p>
       </vs-td>
       <vs-td
        :data="data[indextr].volume"
        v-else-if="data[indextr].tanker && data[indextr].vessel"
       >
        <p
         :style="
          checkCapacityAndVolume(
           data[indextr].vessel.capacity,
           data[indextr].volume
          )
           ? 'color: red'
           : 'color: green'
         "
        >
         {{ getVolume(data[indextr].volume) }}
        </p>
       </vs-td>
      </vs-tr>
     </template>
    </vs-table>
   </div>
  </vx-card>
 </div>
</template>

<script>
import OilTypeCard from '@/components/Card/OilTypeCard.vue'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { formatNumber } from '@/utils/index'
import CardValue from '@/common/Card/CardValue'
import vSelect from 'vue-select'

import {
 OIL_TYPE,
 REFINERY_NAME,
 REFINERY_ID,
 TANKER_TYPE,
} from '../../constants/index'
import _ from 'lodash'

export default {
 name: 'domestic',
 components: {
  vSelect,
  OilTypeCard,
  CardValue,
 },
 data() {
  return {
   formatNumber,
   config: {
    startDate: moment().format('DD/MM/YYYY'),
    endDate: moment().format('DD/MM/YYYY'),
    station: '',
    forwardTanker: '',
    tanker: '',
    vessel: '',
   },
   destinationType: 'transit',
   selectedDate: {
    start: new Date(),
    end: new Date(),
   },
   optionsVessel: [],
   selectedVessel: '',
   descriptionItems: [10, 25, 50, 100],
   oilTransfers: [],
   isActiveRefinary: false,
   selectedStation: null,
   totalOilVolume: 0,
   isCheckCapacityAndVolume: null,
   receive: 0,
   prorate: 0,
  }
 },
 async mounted() {
  await this.$store.dispatch('mpTankerData/getMpVesselByName')
  await this.$store.dispatch('getOilType')
  await this.$store.dispatch('activeOilCard', OIL_TYPE.FISHERIES)
  // this.getVessels()
  // this.getVesselData();

  $('#searchVesselName').keydown(async (e) => {
   await this.$store.dispatch('mpTankerData/getMpVesselByName', e.target.value)
   console.log("e.target.value ", e.target.value, this.mpVesselOption);
  //  await this.getVessel(e.target.value)
  })
 },
 watch: {
  async transfers(newVal, oldVal) {
   if (!_.isEqual(newVal, oldVal)) {
    await this.setData(newVal)
    await this.getOilVolume()
   }
  },
  oilTransfers(newVal, oldVal) {
   for (let i = 0; i < newVal.length; i++) {
    this.oilTransfers[i].index = i
   }
  },
  selectedDate(newVal, oldVal) {
   this.getOilTransfers()
  },
  mpVesselOption(newVal, oldVal) {
    this.optionsVessel = newVal
  },
 },
 computed: {
  ...mapState({
   transfers: (state) => state.oilTransfer.oilTransfers,
   isAllCardActive: (state) => state.greenDieselCardActive.isAllCardActive,
   isIrpcCardActive: (state) => state.greenDieselCardActive.isIrpcCardActive,
   isSprcCardActive: (state) => state.greenDieselCardActive.isSprcCardActive,
   isTopCardActive: (state) => state.greenDieselCardActive.isTopCardActive,
   isBcpCardActive: (state) => state.greenDieselCardActive.isBcpCardActive,
   isPttgcCardActive: (state) => state.greenDieselCardActive.isPttgcCardActive,
   isEssoCardActive: (state) => state.greenDieselCardActive.isEssoCardActive,
   mpVesselOption: (state) => state.mpTankerData.mpVesselOption,
  }),
 },
 methods: {
  async getOilTransfers() {
   this.isActiveRefinary = false

   if (this.selectedVessel) {
    ;(this.config = {
     startDate: this.setDateFormat(this.selectedDate.start),
     endDate: this.setDateFormat(this.selectedDate.end),
     station: this.selectedRefinery && this.selectedRefinery.id,
     forwardTanker: this.selectedForwardTanker && this.selectedForwardTanker.id,
     tanker: this.selectedTanker && this.selectedTanker.id,
     vessel: this.selectedVessel && this.selectedVessel.id,
    }),
     // console.log("this.config ===> ", this.config);
     localStorage.setItem('searchOilTransfer', JSON.stringify(this.config))
    await this.$store.dispatch('oilTransfer/getOilTransfers', this.config)
   } else {
    Swal.fire({
     icon: 'warning',
     title: 'กรุณาเลือกเรือประมง',
     text: 'สำหรับการค้นหาข้อมูลการรับน้ำมันของเรือประมง',
     showConfirmButton: false,
     timer: 2000,
    })
   }

   console.log('this.oilTransfers ', this.oilTransfers)
  },
  async getVessels() {
   await this.$store.dispatch('mpTankerData/getMpVesselByName')
  },
  async getVessel(data) {
   await this.$store.dispatch('mpTankerData/getMpVesselByName', data)
   console.log("vessels change >>> ", data, this.mpVesselOption);
  },
  setDateFormat(date) {
   return moment(date).format('DD/MM/YYYY')
  },
  setDateFormatTh(date) {
   const locale = this.$i18n.locale
   if (locale == 'th') {
    const newDate = moment(date).add(543, 'years').format('DD/MM/YYYY')
    return newDate
   } else {
    const newDate = moment(date).format('DD/MM/YYYY')
    return newDate
   }
  },
  getVolume(data) {
   return formatNumber(Number(data))
  },
  getOilVolume() {
   if (this.config.forwardTanker) {
    this.totalOilVolume = _.sumBy(this.oilTransfers, (o) => {
     if (o.tanker) {
      return o.volume
     }
    })
   } else if (this.config.tanker) {
    this.totalOilVolume = _.sumBy(this.oilTransfers, (o) => {
     if (o.vessel) {
      return o.volume
     }
    })
   } else {
    this.totalOilVolume = _.sumBy(this.oilTransfers, 'volume')
   }

   if (this.totalOilVolume == undefined) {
    this.totalOilVolume = _.sumBy(this.oilTransfers, 'volume')
   }
  },
  checkCapacityAndVolume(capacity, volume) {
   return Number(volume) >= Number(capacity) ? true : false
  },
  async setData(data) {
   if (data.length != 0) {
    this.$vs.loading()
    this.oilTransfers = []
    for (const a of data) {
     a.station_id &&
      (await this.$store.dispatch(
       'mpTankerData/getMpStationById',
       a.station_id
      ))
     a.forward_tanker_id &&
      (await this.$store.dispatch(
       'mpTankerData/getMpForWardTankerById',
       a.forward_tanker_id
      ))
     a.tanker_id &&
      (await this.$store.dispatch('mpTankerData/getMpTankerById', a.tanker_id))
     a.vessel_id &&
      (await this.$store.dispatch('mpTankerData/getMpVesselById', a.vessel_id))

     const station = this.$store.state.mpTankerData.mpStation
     const forwardTanker = this.$store.state.mpTankerData.mpForWardTanker
     const tanker = this.$store.state.mpTankerData.mpTanker
     const vessel = this.$store.state.mpTankerData.mpVessel

     const dataTransfer = {
      ...a,
      station: a.station_id && station,
      forwardTanker: a.forward_tanker_id && forwardTanker,
      tanker: a.tanker_id && tanker,
      vessel: a.vessel_id && vessel,
     }

     this.oilTransfers.push(dataTransfer)
    }
    // console.log("this.oilTransfer >>>>> ", this.oilTransfers);
    this.$vs.loading.close()
   }
  },
  async isActiveNotification(data) {
   this.$vs.loading()
   data.to_s = `<p>${data.vessel.name} <br/> 
        ความจุถัง: ${this.getVolume(data.vessel.capacity)} <br/>
        <b style="color: green">รับน้ำมัน</b>จาก ${data.tanker.name}<br/>
        ปริมาณ ${this.getVolume(data.volume)} ลิตร <br/> วันที่ ${
    data.start_at
   }</p>`
   // console.log("isActiveNotification >> ", data);

   localStorage.setItem('setPositionEventNotification', JSON.stringify(data))
   window.open(`/admin/monitoring`, '_blank')
   await this.$store.dispatch('rts/setPositionEventNotification', data)
   this.$vs.loading.close()
   // this.$router.push(`/monitoring`);
  },
 },
}
</script>

<style lang="scss"
#home {
 .greet-user {
  position: relative;
  .decore-left {
   position: absolute;
   left: 0;
   top: 0;
  }
  .decore-right {
   position: absolute;
   right: 0;
   top: 0;
  }
 }

 @media (max-width: 576px) {
  .decore-left,
  .decore-right {
   width: 140px;
  }
 }
}
#barChartdiv {
 position: absolute;
 top: 0px;
 left: 0px;
 margin: 8px;
}
#nopad {
 padding: 0 !important;
}
.chart {
 // width: 120%;
 height: 365px;
 font-family: 'Prompt', sans-serif;
}
.hello2 {
 height: 500px;
}
.center {
 // width: 200px;
 margin: auto;
}
.red {
 background-color: red;
}
.green {
 background-color: green;
}
@keyframes stretch {
 from {
  transform: rotate(0deg) translateX(15px) rotate(0deg);
 }
 to {
  transform: rotate(360deg) translateX(15px) rotate(-360deg);
 }
}

/* The element to apply the animation to */
.Animatio {
 position: relative;
 animation-duration: 10s;
 animation: stretch 2s ease-out 0s infinite none running;
}
.setHeight {
 height: 100%;
}
.fullScreenButton {
 position: absolute;
 right: 0px;
 top: 0px;
}
.cardDate {
 height: 62px;
}
.boldText {
 font-weight: bold;
}
.active {
 background-color: #cccccc;
}
.green {
 background-color: red;
}
.lighten-1 {
 background-color: red;
}
.v-btn .v-btn--active {
 background-color: red;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
 background-color: red;
}
</style>
